import {
  Directive,
  Input,
  input,
  model,
  OnChanges,
  OnDestroy,
  SimpleChanges
} from '@angular/core';

import { NgControl } from '@angular/forms';

import { Subject } from 'rxjs';
import { coerceBooleanProperty } from '../../../utils/coercion';
import { AppFormFieldControl } from '../../legacy/form/form-field/form-field-control/form-field-control';
import { InputFieldsValueAccessor } from './input-fields-value-accessor';

@Directive()
export abstract class InputFieldsDirective<T>
  extends InputFieldsValueAccessor<T>
  implements AppFormFieldControl<T>, OnChanges, OnDestroy
{
  protected ngControl: NgControl;

  stateChanges: Subject<void> = new Subject();

  @Input({
    transform: (value: any) => coerceBooleanProperty(value)
  })
  disabled = false;

  readonly required = input<boolean, unknown>(false, {
    transform: value => coerceBooleanProperty(value)
  });

  readonly readOnly = input<boolean, boolean>(false, {
    transform: value => coerceBooleanProperty(value)
  });

  readonly id = input<string>(undefined);
  readonly placeholder = input<string>(undefined);

  // TODO: remove them, as they are probably too specific for the general InputFieldsDirective
  readonly count = input<boolean>(undefined);
  readonly counter = model<number>(undefined);

  /**
   * temporary workaround. Angular shows warnings when [disabled] is set on an element
   * with already has [formControl] or formControlName attribute. Because those two directives
   * are part of ReactiveForms, Angular suggests to disable controls via FormControl objects, not in the
   * template itself (which is normal for TemplateDrivenForms).
   * We could use FormControl passed from the parent element, but we cannot inject it right now,
   * because of NG_VALUE_ACCESSOR - related FormControl tries to inject this class, and when this class
   * tries to inject FormControl (NgControl) in the same time, we got cyclic dependency.
   *
   * In order to fix it properly, we need to find a way to inject related FormControl (NgControl) into our
   * custom form control, and then we can use it directly.
   */
  readonly forceDisabled = input(false);

  get errors() {
    return this.ngControl.errors;
  }

  get touched() {
    return this.ngControl.touched;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  ngOnChanges(changes: SimpleChanges) {
    Object.keys(changes).forEach(key => {
      if (changes[key].currentValue !== changes[key].previousValue)
        this.stateChanges.next();
    });
  }

  ngOnDestroy() {
    this.stateChanges.complete();
  }
}
